import { RootState } from 'store';
import createResourceListSelectors from 'store/ResourceListSelectors';
import { CompetitorState, ResourceListSelectors } from 'typings/state';

const selectors: ResourceListSelectors = createResourceListSelectors(
    (state: RootState): CompetitorState => state.competitor,
);

export default selectors;
